import { Box, Flex, Progress, Spinner, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import React from 'react';

// Loader shown by @react-pdf-viewer while a (possibly large) PDF downloads/renders.
// DS-styled + shows download progress so the user knows a heavy file is loading.
const renderLoader = (progress: number) => {
  return (
    <Flex
      align='center'
      justify='center'
      direction='column'
      gap={4}
      w='100%'
      h='100%'
      bg='bg.canvas'
    >
      <Spinner
        color='primary.solid'
        emptyColor='border.default'
        size='lg'
        speed='0.7s'
        thickness='3px'
      />
      <Box w='240px' textAlign='center'>
        <Text mb={2} color='text.muted' fontSize='sm' fontWeight={500}>
          {t('common.loadingFile')}
        </Text>
        <Progress
          bg='border.default'
          borderRadius='full'
          colorScheme='purple'
          size='sm'
          value={progress}
        />
        <Text mt={1.5} color='text.subtle' fontSize='xs'>
          {Math.round(progress)}%
        </Text>
      </Box>
    </Flex>
  );
};

export default renderLoader;
